import { Record, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { int32_type, record_type, decimal_type, union_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { interpolate, toText } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { fromParts } from "../fable_modules/fable-library-js.4.24.0/Decimal.js";

export class Symbol$ extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Left", "Right"];
    }
}

export function Symbol$_$reflection() {
    return union_type("Shopfoo.Domain.Types.Common.Symbol", [], Symbol$, () => [[["Item", string_type]], [["Item", string_type]]]);
}

export class Currency extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["EUR", "USD"];
    }
}

export function Currency_$reflection() {
    return union_type("Shopfoo.Domain.Types.Common.Currency", [], Currency, () => [[], []]);
}

export function Currency__get_Symbol(this$) {
    if (this$.tag === 1) {
        return new Symbol$(0, ["$"]);
    }
    else {
        return new Symbol$(1, ["€"]);
    }
}

export class Money extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Dollars", "Euros"];
    }
}

export function Money_$reflection() {
    return union_type("Shopfoo.Domain.Types.Common.Money", [], Money, () => [[["value", decimal_type]], [["value", decimal_type]]]);
}

export function Money_ByCurrency(currency, value) {
    if (currency.tag === 0) {
        return new Money(1, [value]);
    }
    else {
        return new Money(0, [value]);
    }
}

export function Money__get_Currency(this$) {
    if (this$.tag === 1) {
        return new Currency(0, []);
    }
    else {
        return new Currency(1, []);
    }
}

export function Money__get_Value(this$) {
    if (this$.tag === 1) {
        return this$.fields[0];
    }
    else {
        return this$.fields[0];
    }
}

export function Money__WithValue_32C73145(this$, value) {
    if (this$.tag === 1) {
        return new Money(1, [value]);
    }
    else {
        return new Money(0, [value]);
    }
}

export function Money_Format(currency, value) {
    const matchValue = Currency__get_Symbol(currency);
    if (matchValue.tag === 1) {
        return toText(interpolate("%.2f%P() %s%P()", [value, matchValue.fields[0]]));
    }
    else {
        return toText(interpolate("%s%P() %.2f%P()", [matchValue.fields[0], value]));
    }
}

export function Money__get_ValueWithCurrencySymbol(this$) {
    return Money_Format(Money__get_Currency(this$), Money__get_Value(this$));
}

export function Money_map(f, money) {
    if (money.tag === 1) {
        return new Money(1, [f(money.fields[0])]);
    }
    else {
        return new Money(0, [f(money.fields[0])]);
    }
}

function MoneyModule_$007CValueWithCase$007C(_arg) {
    if (_arg.tag === 1) {
        return [_arg.fields[0], (value_3) => (new Money(1, [value_3]))];
    }
    else {
        return [_arg.fields[0], (value_1) => (new Money(0, [value_1]))];
    }
}

/**
 * Apply the computation with the 2 given moneys if they are of the same case (meaning the same currency).
 */
export function MoneyModule_tryCompute(_arg, _arg_1, f) {
    const activePatternResult = MoneyModule_$007CValueWithCase$007C(_arg);
    const cx = activePatternResult[1];
    const activePatternResult_1 = MoneyModule_$007CValueWithCase$007C(_arg_1);
    if (equals(cx(fromParts(0, 0, 0, false, 0)), activePatternResult_1[1](fromParts(0, 0, 0, false, 0)))) {
        return cx(f(activePatternResult[0], activePatternResult_1[0]));
    }
    else {
        return undefined;
    }
}

export class Lang extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["English", "French", "Latin"];
    }
}

export function Lang_$reflection() {
    return union_type("Shopfoo.Domain.Types.Common.Lang", [], Lang, () => [[], [], []]);
}

export class SKU extends Record {
    constructor(Type, Value) {
        super();
        this.Type = Type;
        this.Value = Value;
    }
}

export function SKU_$reflection() {
    return record_type("Shopfoo.Domain.Types.Common.SKU", [], SKU, () => [["Type", SKUType_$reflection()], ["Value", string_type]]);
}

export class FSID extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["FSID"];
    }
}

export function FSID_$reflection() {
    return union_type("Shopfoo.Domain.Types.Common.FSID", [], FSID, () => [[["Item", int32_type]]]);
}

export class ISBN extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["ISBN"];
    }
}

export function ISBN_$reflection() {
    return union_type("Shopfoo.Domain.Types.Common.ISBN", [], ISBN, () => [[["Item", string_type]]]);
}

export class OLID extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["OLID"];
    }
}

export function OLID_$reflection() {
    return union_type("Shopfoo.Domain.Types.Common.OLID", [], OLID, () => [[["Item", string_type]]]);
}

export class SKUUnknown extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["SKUUnknown"];
    }
}

export function SKUUnknown_$reflection() {
    return union_type("Shopfoo.Domain.Types.Common.SKUUnknown", [], SKUUnknown, () => [[]]);
}

export class SKUType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FSID", "ISBN", "OLID", "Unknown"];
    }
}

export function SKUType_$reflection() {
    return union_type("Shopfoo.Domain.Types.Common.SKUType", [], SKUType, () => [[["Item", FSID_$reflection()]], [["Item", ISBN_$reflection()]], [["Item", OLID_$reflection()]], []]);
}

export function SKU__get_AsFSID(this$) {
    const matchValue = this$.Type;
    if (matchValue.tag === 0) {
        return matchValue.fields[0];
    }
    else {
        return undefined;
    }
}

export function Shopfoo_Domain_Types_Common_FSID__FSID_get_Value(this$) {
    return `FS-${this$.fields[0]}`;
}

export function Shopfoo_Domain_Types_Common_FSID__FSID_get_AsSKU(this$) {
    return new SKU(new SKUType(0, [this$]), Shopfoo_Domain_Types_Common_FSID__FSID_get_Value(this$));
}

export function Shopfoo_Domain_Types_Common_ISBN__ISBN_get_Value(this$) {
    return this$.fields[0];
}

export function Shopfoo_Domain_Types_Common_ISBN__ISBN_get_AsSKU(this$) {
    return new SKU(new SKUType(1, [this$]), Shopfoo_Domain_Types_Common_ISBN__ISBN_get_Value(this$));
}

export function Shopfoo_Domain_Types_Common_OLID__OLID_get_Value(this$) {
    return this$.fields[0];
}

export function Shopfoo_Domain_Types_Common_OLID__OLID_get_AsSKU(this$) {
    return new SKU(new SKUType(2, [this$]), Shopfoo_Domain_Types_Common_OLID__OLID_get_Value(this$));
}

export function Shopfoo_Domain_Types_Common_SKUUnknown__SKUUnknown_get_Value(this$) {
    return "";
}

export function Shopfoo_Domain_Types_Common_SKUUnknown__SKUUnknown_get_AsSKU(this$) {
    return new SKU(new SKUType(3, []), Shopfoo_Domain_Types_Common_SKUUnknown__SKUUnknown_get_Value(this$));
}

